import { render, staticRenderFns } from "./AssesmentModal.vue?vue&type=template&id=709c4715&"
import script from "./AssesmentModal.vue?vue&type=script&lang=js&"
export * from "./AssesmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports